import { Injectable } from '@angular/core';
import {  BehaviorSubject, distinctUntilChanged, Observable, Subject, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EventsService {
  backEvent$: Subject<boolean>;
  selectedIndexEvent$: Subject<number>;

  private _isDesktop :BehaviorSubject<boolean>;

  constructor(
  ) { 
    this.backEvent$ = new Subject<boolean>();
    this.selectedIndexEvent$ = new Subject<number>();
    this._isDesktop =  new BehaviorSubject<boolean>(this.isDesktop);

  }

  backEvent(): Observable<boolean> {
    return this.backEvent$.asObservable()
      .pipe();
  }

  selectedIndexEvent(): Observable<number> {
    return this.selectedIndexEvent$.asObservable()
  }

  onResize(size: number) {
    this._isDesktop.next(size > 960);
  }

  isDesktopView(): Observable<boolean> {
    return this._isDesktop.asObservable()
      .pipe(
        distinctUntilChanged(),
      );
  }

  /**
  * @description Indicates if the screen size corresponds to a desktop
  */
  get isDesktop(): boolean {
    return  window.innerWidth > 960;
  }

}
